import axios from '@/libs/api.request.js';

const app = {
    // 根据openId获取token，已经绑定手机号码情况下
    getTokenByOpenId(data) {
      return axios.post({
          url: 'https://openapp.azsoft.xin/api/app/we-chat/request-token-by-open-id',
          data:data
      });
    },
    // 获取手机验证码，手机号码未绑定
    getVerificationCode: (phoneNumber) => {
      return axios.get({
          url: 'https://openapp.azsoft.xin/api/app/sms/verification-code?phoneNumber='+phoneNumber
      })
    },
    // 根据Phone获取token
    getTokenByPhoneNumber(data) {
      return axios.post({
          url: 'https://openapp.azsoft.xin/api/app/sms/request-token-by-phone-number',
          data:data
      },'/app');
    },
    //切换租户
    setTenantSwitchById(id) {
      return axios.post({
          url: 'https://openapp.azsoft.xin/api/Account/TenantSwitchById?id='+id
      });
    },
    //获取应用配置信息
    getApplicationConfiguration() {
      return axios.get({url: 'https://rbac-dev.azsoft.xin/api/abp/application-configuration'});
    },
    //获取天气
    getWeather() {
      return axios.get({url: '/api/?version=v6&appid=75721589&appsecret=ra1IEX9K'},'/weather');
    }
};

export default app;


// WEBPACK FOOTER //
// ./src/api/api-app.js